// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3Wsdv","loaderOuter":"PageOverlayLoader_loaderOuter__1iglM"};